import { useSelector } from "react-redux";

export const useUserId = () => {
  const { user } = useSelector((state) => state.auth);
  return user ? user.id : 1;
};
